var Backbone = require('backbone'),
    _ = require('underscore'),
    Stamp = require('./stamp');


/* Base Abstract Class */

module.exports = Backbone.Collection.extend({

    model: Stamp,

    initialize: function() {

        this.userHasStamps = false;
    },
    // Apply a case sensitive sort of the subject; this is so the first will be the default stamp for new stamp notes
    comparator: function(s) {
        return s.get('subject').toLowerCase();
    },

    parse: function(resp) {

        this.userHasStamps = resp && resp.length > 0;
        return resp;


    },
    userHasStamps: function() {

        return this.userHasStamps;

    },

    /* Cache data to populate the dropdown text context */
    getDataToPopulateCreateStampDropDown: function() {

        if ( this.dataToPopulateCreateStampDropdown )
            return this.dataToPopulateCreateStampDropdown;

        this.dataToPopulateCreateStampDropdown = this.toJSON(); // ( just extraneous model attributes ok -- I think already sorted )

        return this.dataToPopulateCreateStampDropdown;

    },

    getDefaultStampForNewNote: function() {

        if ( !this.userHasStamps )
            return null;

        return this.at(0);

    },

    // note: won't be able to use for pageNotes that don't have a stamp id associated with them
    getStampModelFromId: function(id) {

        return this.findWhere({id: id});

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/user/stamps/stamps.js
 ** module id = 92
 ** module chunks = 0
 **/